import React from 'react';
import Repeat from 'react-repeat-component';

import styles from './SimpleCaseStudyPlaceholder.module.scss';

import { Container } from 'common/components/Layout/Layout';
import ContentBar from 'common/components/Placeholder/components/ContentBar/ContentBar';

const SimpleCaseStudyPlaceholder = () => (
  <Container className={styles.SimpleCaseStudyPlaceholder}>
    <div className={styles.CaseStudyColumn}>
      <div className={styles.RecentCaseStudy}>
        <Repeat times={6}>
          {i => (
            <ContentBar key={i} className={styles.SimpleCaseStudyPlaceholder} />
          )}
        </Repeat>
      </div>
    </div>
  </Container>
);

export default SimpleCaseStudyPlaceholder;



// WEBPACK FOOTER //
// ./src/views/SimpleCaseStudy/placeholder/SimpleCaseStudyPlaceholder.js